import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment as env } from 'src/environments/environment';
import { UserDetail } from '../../models/user-detail';
import { jwtDecode } from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { StoreService } from '../store-service/store.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private storeService: StoreService,
    private authService: MsalService,
    private http: HttpClient
  ) {}

  async getAccessToken(): Promise<string> {
    const redirectResponse =
      await this.authService.instance.handleRedirectPromise();
    if (redirectResponse !== null) {
      // Acquire token silent success
      let accessToken = redirectResponse.accessToken;
      return accessToken;
    } else {
      // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
      const account = this.authService.instance.getAllAccounts()[0];

      const accessTokenRequest = {
        scopes: [env.base_api_scope],
        account: account,
      };

      let response = await this.authService.instance.acquireTokenSilent(
        accessTokenRequest
      );
      let accessToken = response.accessToken;
      return accessToken;
    }
  }

  async getUserDetail(): Promise<UserDetail> {
    if (this.storeService.user.isLoaded) {
      return this.storeService.user;
    }

    let user: UserDetail = new UserDetail();

    // Get general detail
    const account: any = this.authService.instance.getAllAccounts()[0];
    user.name = account.name!;
    user.email = account.username;
    user.id = account.idTokenClaims.oid;
    user.lanid = await this.getLanid(user);
    user.imageURL = user.lanid
      ? `https://mysite.na.xom.com/User%20Photos/Profile%20Pictures/${user.lanid.replace(
          '\\',
          '_'
        )}_MThumb.jpg`
      : '';

    // Get role from JWT token
    const decoded = jwtDecode<any>(await this.getAccessToken());
    const roles = decoded.roles;
    if (roles) {
      user.canMaintainSupplierProfile = roles.filter(
        (role: string) => role == 'SupplierProfile.ReadWrite'
      )
        ? true
        : false;
      user.canViewAdminPage = user.canMaintainSupplierProfile;
    }

    // Keep in store
    user.isLoaded = true;
    this.storeService.assignUser(user);

    return user;
  }

  async getLanid(user: UserDetail): Promise<string> {
    if (!user.id) return '';
    const url = `https://graph.microsoft.com/beta/users?$filter=id eq '${user.id}'&$select=id,displayName,mail,extension_d6448b80620845bf89c63bb6933c28da_XOM_FullLANID,jobTitle,givenName,surname`;
    const response: any = await this.http.get(url).toPromise();
    return response.value[0]
      .extension_d6448b80620845bf89c63bb6933c28da_XOM_FullLANID;
  }
}
